import { IObjectObserver } from "./IObjectObserver";
import { ExternalLinksSettingsDataModel, ExternalLinksSettingsViewModel, ExternalLinksSettingsDMKey } from "../shared/models";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ObjectObserverFactory } from "./objectObserverFactory";
import { ContentType } from "../shared/contentTypes";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ConfirmationModalDialogComponent } from "../modalDialogs/confirmationModalDialog/confirmationModalDialog.component";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";

@Injectable({
  providedIn: "root"
})
export class ExternalLinksSettingsService {
  private _externalLinksSettingettingsObsServer: IObjectObserver<ExternalLinksSettingsDataModel>;

  constructor(private objObsInjectHelper: CircularInjectionHelper
    , private _bottomSheetHelperService: BottomSheetHelperService) {
    this._externalLinksSettingettingsObsServer = ObjectObserverFactory.GetObjectObserverByInjectionHelper<ExternalLinksSettingsDataModel>(ContentType.ExternalLinksSettings, objObsInjectHelper);
  }

  public get ObserveChanges(): Observable<(string | number)[]> {
    return this._externalLinksSettingettingsObsServer.ObserveChanges;
  }

  public GetExternalLinksSettings(): Promise<ExternalLinksSettingsViewModel> {
    const me = this;
    return new Promise<ExternalLinksSettingsViewModel>((resolve, reject) => {
      me._externalLinksSettingettingsObsServer.GetObjectsByFilter(e => e.id === ExternalLinksSettingsDMKey)
        .then(response => {
          if (response && response.length > 0) {
            resolve(me.mapExternalLinksSettingsToViewModel(response[0]));
          } else {
            resolve(null);
          }
        })
        .catch(e => {
          me.objObsInjectHelper.coreLogService.error("GetExternalLinksSettings.GetExternalLinksSettings", "GetObjectsByFilter", e);
          reject();
        });
    });
  }

  public RouteToExternalLinks(url: string = "", useLegalNotice: boolean = false): Promise<void> {
    const me = this;
    return new Promise<void>((resolve, reject) => {
      me.GetExternalLinksSettings()
        .then(response => {
          if (url) {
            if (response && useLegalNotice) {
              me.openConfirmationModal(response, url);
            } else {
              window.open(url, "_system");
            }
          } else {
            if (response) {
              if (response.useLegalNotice) {
                me.openConfirmationModal(response, response.url);
              } else {
                window.open(response.url, "_system");
              }
            } else {
              me.objObsInjectHelper.coreLogService.info("GetExternalLinksSettings.RouteToExternalLinks", "GetExternalLinksSettings is null");
            }
          }
        })
        .catch(e => {
          me.objObsInjectHelper.coreLogService.error("GetExternalLinksSettings.RouteToExternalLinks", "GetExternalLinksSettings", e);
          reject();
        });
    });
  }

  private openConfirmationModal(response: any, targetUrl: string) {
    const me = this;
    const bottomSheetRef = me._bottomSheetHelperService.open(ConfirmationModalDialogComponent, {
      data: {
        title: "phExternalLinkModal_confirmation_Title",
        description: () => response.legalText,
        buttonText: "phExternalLinkModal_confirm_Button_Text"
      }
    });
    bottomSheetRef.afterDismissed().subscribe((result: boolean) => {
      if (result) {
        window.open(targetUrl, "_system");
      }
    });
  }

  private mapExternalLinksSettingsToViewModel(model: ExternalLinksSettingsDataModel): ExternalLinksSettingsViewModel {
    if (model) {
      const viewModel: ExternalLinksSettingsViewModel = new ExternalLinksSettingsViewModel();
      viewModel.url = model.url;
      viewModel.useLegalNotice = model.use_legal_notice;
      viewModel.legalTextDE = model.legal_text_de;
      viewModel.legalTextEN = model.legal_text_en;
      return viewModel;
    } else {
      return null;
    }
  }
}
